import React, { Component } from 'react';
import { Footer } from '../Components/Footer';
import ArticleCard from '../Components/ArticleCard';
import NewsletterSignup from '../Components/NewsletterSignup';
import Pagination from '../Components/Pagination';

class Articles extends Component {
    constructor(props) {
        super(props);
        this.articlesRef = React.createRef();
        this.state = {
            date: new Date(),
            articleList: [],
            loading: true,
            currentPage: 1,
            articlesPerPage: 6,
            totalPages: 0,
            name: '',
            email: '',
            searchTerm: '',
            selectedCategory: '',
        };
        this.getArticles();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    getArticles(page = 1, searchTerm = '', category = '') {
        const useMock = false;

        if (useMock) {
            const withPagination = true;
            let allMockArticles;
            if (!withPagination) {
                allMockArticles = [
                    {
                        id: 1,
                        imagem: '/images/blog/example.svg',
                        titulo: 'Como interpretar os principais indicadores fiscais do país',
                        resumo: 'Entenda como a tecnologia influencia a eficiência e transparência na gestão dos recursos públicos',
                        autor: 'João Silva',
                        data_publicacao: '2024-05-10',
                        categoria: 'ANÁLISES',
                    },
                    {
                        id: 2,
                        imagem: '/images/blog/example.svg',
                        titulo: 'Entenda os principais indicadores fiscais do Brasil',
                        resumo: 'Um guia prático para interpretar os dados fiscais mais relevantes do país.',
                        autor: 'Maria Oliveira',
                        data_publicacao: '2024-05-08',
                        categoria: 'ANÁLISES',
                    },
                    {
                        id: 3,
                        imagem: '/images/blog/example.svg',
                        titulo: 'Transparência fiscal: desafios e oportunidades',
                        resumo: 'Análise dos avanços e obstáculos na busca por maior clareza nas contas públicas.',
                        autor: 'Carlos Souza',
                        data_publicacao: '2024-05-05',
                        categoria: 'TRANSPARÊNCIA',
                    },
                    {
                        id: 4,
                        imagem: '/images/blog/example.svg',
                        titulo: 'O papel da economia comportamental nas finanças públicas',
                        resumo: 'Como o comportamento humano influencia decisões fiscais e políticas públicas.',
                        autor: 'Ana Paula',
                        data_publicacao: '2024-05-02',
                        categoria: 'ECONOMIA',
                    },
                    {
                        id: 5,
                        imagem: '/images/blog/example.svg',
                        titulo: 'Tendências em arrecadação tributária para 2024',
                        resumo: 'Veja as previsões e mudanças esperadas na arrecadação de impostos no próximo ano.',
                        autor: 'Bruno Lima',
                        data_publicacao: '2024-04-28',
                        categoria: 'TENDÊNCIAS',
                    },
                    {
                        id: 6,
                        imagem: '/images/blog/example.svg',
                        titulo: 'Estudos técnicos: impacto das reformas fiscais',
                        resumo: 'Avaliação dos efeitos das recentes reformas no cenário econômico nacional.',
                        autor: 'Fernanda Costa',
                        data_publicacao: '2024-04-25',
                        categoria: 'ESTUDOS TÉCNICOS',
                    },
                    {
                        id: 7,
                        imagem: '/images/blog/example.svg',
                        titulo: 'Como interpretar relatórios de execução orçamentária',
                        resumo: 'Dicas essenciais para entender os relatórios publicados pelo governo.',
                        autor: 'Ricardo Alves',
                        data_publicacao: '2024-04-20',
                        categoria: 'TRANSPARÊNCIA',
                    },
                ];
            } else {
                const categorias = ['ANÁLISES', 'ECONOMIA', 'ESTUDOS TÉCNICOS', 'TENDÊNCIAS', 'TRANSPARÊNCIA'];

                allMockArticles = Array.from({ length: 300 }, (_, i) => ({
                    id: i + 1,
                    imagem: '/images/blog/example.svg',
                    titulo: `Artigo Mock ${i + 1}`,
                    resumo: `Resumo do artigo mock ${i + 1}`,
                    autor: `Autor ${i + 1}`,
                    data_publicacao: '2024-05-10',
                    categoria: categorias[i % categorias.length],

                }));
            }

            // Filtrar pelo termo de busca, se houver
            if (searchTerm) {
                const lower = searchTerm.toLowerCase();
                allMockArticles = allMockArticles.filter(
                    art =>
                        art.titulo.toLowerCase().includes(lower) ||
                        art.resumo.toLowerCase().includes(lower) ||
                        art.autor.toLowerCase().includes(lower)
                );
            }

            if (category) {
                allMockArticles = allMockArticles.filter(
                    art => art.categoria === category
                );
            }

            const { articlesPerPage } = this.state;
            const totalPages = Math.ceil(allMockArticles.length / articlesPerPage);
            const startIdx = (page - 1) * articlesPerPage;
            const endIdx = startIdx + articlesPerPage;
            const pageArticles = allMockArticles.slice(startIdx, endIdx);

            setTimeout(() => {
                this.setState({
                    articleList: pageArticles,
                    totalPages,
                    currentPage: page,
                    loading: false
                });
            }, 500);
        } else {
            let url = `${process.env.REACT_APP_API_URL}/postagens/?page=${page}&page_size=${this.state.articlesPerPage}`;
            if (searchTerm) {
                url += `&q=${encodeURIComponent(searchTerm)}`;
            }
            if (category) {
                url += `&categoria=${encodeURIComponent(category)}`; // só vai funcionar quando a API aceitar
            }
            fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then(resp => resp.json())
                .then(resp => {
                    if (resp.results) {
                        this.setState({
                            articleList: resp.results,
                            totalPages: Math.ceil(resp.count / this.state.articlesPerPage),
                            currentPage: page,
                            loading: false
                        });
                    } else {
                        this.setState({ loading: false });
                    }
                }).catch(err => {
                    console.log(err);
                    this.setState({ loading: false });
                });
        }
    }

    handlePageChange = (page) => {
        this.setState({ loading: true }, () => {
            this.getArticles(page);
            if (this.articlesRef.current) {
                this.articlesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

                setTimeout(() => {
                    window.scrollBy({ top: -80, left: 0, behavior: 'smooth' });
                }, 400);
            }
        });
    }


    handleChange = (e) => {
        // TODO: implementar a chamada do envio de newsletter
    }

    handleCategorySelect = (category) => {
        this.setState({ selectedCategory: category, loading: true, currentPage: 1 }, () => {
            this.getArticles(1, this.state.searchTerm, category);
        });
    };

    handleShowAll = () => {
        this.setState({ selectedCategory: '', loading: true, currentPage: 1 }, () => {
            this.getArticles(1, this.state.searchTerm, '');
        });
    };

    handleSearchInputChange = (e) => {
        this.setState({ searchTerm: e.target.value }, () => {
            // Opcional: debounce para evitar chamadas excessivas
            clearTimeout(this._searchTimeout);
            this._searchTimeout = setTimeout(() => {
                this.handleSearch();
            }, 400);
        });
    };

    handleSearch = (page = 1) => {
        this.setState({ loading: true }, () => {
            this.getArticles(page, this.state.searchTerm, this.state.selectedCategory);
        });
    };

    render() {
        const { articleList, loading, name, email } = this.state;

        // Função utilitária para retornar o ícone conforme a categoria (usada nos filtros comentados)
        // eslint-disable-next-line no-unused-vars
        const getCategoryIconSrc = (categoria) => {
            switch (categoria) {
                case 'ANÁLISES':
                    return '/images/icons/chart.svg';
                case 'ECONOMIA':
                    return '/images/icons/diagram_up.svg';
                case 'ESTUDOS TÉCNICOS':
                    return '/images/icons/clipboard_text.svg';
                case 'TENDÊNCIAS':
                    return '/images/icons/chat_square_check.svg';
                case 'TRANSPARÊNCIA':
                    return '/images/icons/round_graph.svg';
                default:
                    return '/images/icons/Buildings.svg';
            }
        };

        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <div className="container">
                    {/* {articleList && articleList.length > 0 &&
                        <div className='home-first-block home-blocks'>
                            <img
                                src={articleList[0].imagem}                                
                                alt={articleList[0].titulo}
                                style={{ maxHeight: isMobile ? '180px' : 'auto', maxWidth: isMobile ? 'min(100%, 767px)' : 'min(100%, 1140px)', minWidth: isMobile ? '317px' : '500px', borderRadius: '30px', marginBottom: '20px' }}
                            />

                            <div className='home-first-block-left'>
                                <TitleCard
                                    iconLeft={<img
                                        src={getCategoryIconSrc(articleList[0].categoria)}
                                        width="18"
                                        alt={articleList[0].categoria ? articleList[0].categoria : 'OUTROS'}
                                    />}
                                    label={articleList[0].categoria ? articleList[0].categoria : 'OUTROS'}
                                />

                                <span className='title-text title-text-article'>
                                    {articleList[0].titulo}
                                </span>
                                <span className='resume-text' style={{ marginBottom: '20px', color: 'gray' }}>
                                    {/<[a-z][\s\S]*>/i.test(articleList[0].resumo)
                                        ? (
                                            <span
                                                className='article-detail-content mt-3'
                                                dangerouslySetInnerHTML={{ __html: articleList[0].resumo }}
                                            />
                                        )
                                        : (
                                            <span className='article-detail-content mt-3'>
                                                {articleList[0].resumo}
                                            </span>
                                        )
                                    }
                                </span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '30px' }}>
                                    <div>
                                        <img
                                            src="/images/blog/user.svg"
                                            width="20"
                                            alt="Autor"
                                        />
                                        <span style={{ fontSize: '14px', color: '#818181', marginLeft: '5px' }}>{articleList[0].autor}</span>
                                    </div>

                                    <div>
                                        <img
                                            src="/images/blog/calendar.svg"
                                            width="20"
                                            alt="Data"
                                        />
                                        <span style={{ fontSize: '14px', color: '#818181', marginLeft: '5px' }}>
                                            {formatDate(articleList[0].data_publicacao)}
                                        </span>
                                    </div>

                                </div>

                                <Link to={`/article-details/${articleList[0].id}`} style={{ textDecoration: 'none' }}>
                                    <Button
                                        label="Ler artigo"
                                        $variant="primary"
                                        size="small"
                                        iconRight={<ChevronRight />}
                                    />
                                </Link>
                            </div>

                        </div>
                    } */}

                    {/* <div className='article-filters-block'>
                        <div className='article-filters-inner-block'>
                            <img
                                src="/images/blog/filter.svg"
                                width="20"
                                alt="Filter"
                            />
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Leia por categoria:</span>
                            <TitleCard
                                iconLeft={<img src={getCategoryIconSrc('ANÁLISES')} width="18" alt="ANÁLISES" />}
                                label='ANÁLISES'
                                style={{ cursor: 'pointer', background: selectedCategory === 'ANÁLISES' ? '#e6eaff' : undefined }}
                                onClick={() => this.handleCategorySelect('ANÁLISES')}
                            />
                            <TitleCard
                                iconLeft={<img src={getCategoryIconSrc('ECONOMIA')} width="18" alt="ECONOMIA" />}
                                label='ECONOMIA'
                                style={{ cursor: 'pointer', background: selectedCategory === 'ECONOMIA' ? '#e6eaff' : undefined }}
                                onClick={() => this.handleCategorySelect('ECONOMIA')}
                            />
                            <TitleCard
                                iconLeft={<img src={getCategoryIconSrc('ESTUDOS TÉCNICOS')} width="18" alt="ESTUDOS TÉCNICOS" />}
                                label='ESTUDOS TÉCNICOS'
                                style={{ cursor: 'pointer', background: selectedCategory === 'ESTUDOS TÉCNICOS' ? '#e6eaff' : undefined }}
                                onClick={() => this.handleCategorySelect('ESTUDOS TÉCNICOS')}
                            />
                            <TitleCard
                                iconLeft={<img src={getCategoryIconSrc('TENDÊNCIAS')} width="18" alt="TENDÊNCIAS" />}
                                label='TENDÊNCIAS'
                                style={{ cursor: 'pointer', background: selectedCategory === 'TENDÊNCIAS' ? '#e6eaff' : undefined }}
                                onClick={() => this.handleCategorySelect('TENDÊNCIAS')}
                            />
                            <TitleCard
                                iconLeft={<img src={getCategoryIconSrc('TRANSPARÊNCIA')} width="18" alt="TRANSPARÊNCIA" />}
                                label='TRANSPARÊNCIA'
                                style={{ cursor: 'pointer', background: selectedCategory === 'TRANSPARÊNCIA' ? '#e6eaff' : undefined }}
                                onClick={() => this.handleCategorySelect('TRANSPARÊNCIA')}
                            />
                            <TitleCard
                                iconLeft={<img src={getCategoryIconSrc('OUTROS')} width="18" alt="OUTROS" />}
                                label='OUTROS'
                                style={{ cursor: 'pointer', background: selectedCategory === 'OUTROS' ? '#e6eaff' : undefined }}
                                onClick={() => this.handleCategorySelect('OUTROS')}
                            />
                            <div style={{ cursor: 'pointer', fontWeight: selectedCategory === '' ? 'bold' : undefined }} onClick={this.handleShowAll}>
                                <span style={{ fontSize: '14px' }}>Ver todos os artigos</span>
                                <ChevronRight />
                            </div>
                        </div>
                    </div> */}

                    <div className='search-block'>
                        <div className='search-inner-block'>
                            <input
                                type="text"
                                placeholder="Pesquisar artigos"
                                value={this.state.searchTerm}
                                onChange={this.handleSearchInputChange}
                                onKeyDown={e => { if (e.key === 'Enter') this.handleSearch(); }}
                                style={{
                                    width: '100%',
                                    height: '44px',
                                    borderRadius: '8px',
                                    border: '1px solid #818181',
                                    background: '#fff',
                                    padding: '0 44px 0 16px',
                                    fontSize: '16px',
                                    outline: 'none'
                                }}
                            />
                            <span
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '45%',
                                    transform: 'translateY(-50%)',
                                    color: '#4654A3',
                                    fontSize: '26px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
                                    <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    {
                        articleList && articleList.length > 0 ? (
                            <div ref={this.articlesRef} className='text-and-img-block justify-content-center align-items-center cards mt-4' style={{ marginBottom: '73px' }}>
                                {articleList.map((article) => (
                                    <ArticleCard
                                        key={article.id}
                                        id={article.id}
                                        image={article.imagem}
                                        alt={article.titulo}
                                        title={article.titulo}
                                        text={article.resumo}
                                        author={article.autor}
                                        date={article.data_publicacao}
                                        category={article.categoria ? article.categoria : 'OUTROS'}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '250px',
                                margin: '40px',
                                borderRadius: '16px'
                            }}>
                                {loading ? (
                                    <>
                                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                            <circle cx="24" cy="24" r="20" stroke="#37428E" strokeWidth="4" opacity="0.2" />
                                            <circle cx="24" cy="24" r="20" stroke="#37428E" strokeWidth="4" strokeDasharray="100" strokeDashoffset="60">
                                                <animateTransform attributeName="transform" type="rotate" from="0 24 24" to="360 24 24" dur="1s" repeatCount="indefinite" />
                                            </circle>
                                        </svg>
                                        <span style={{ marginTop: '18px', fontSize: '20px', color: '#37428E', fontWeight: 500 }}>Carregando artigos...</span>
                                    </>
                                ) : (
                                    <>
                                        <svg width="68" height="68" viewBox="0 0 48 48" fill="none">
                                            <rect x="8" y="12" width="32" height="24" rx="4" fill="#F0F0F0" />
                                            <path d="M16 20H32M16 26H32" stroke="#818181" strokeWidth="2" strokeLinecap="round" />
                                            <circle cx="24" cy="34" r="2" fill="#818181" />
                                        </svg>
                                        <span className='title-text'>Nenhum artigo encontrado</span>
                                        <span style={{ fontSize: '18px', color: '#818181', marginTop: '6px' }}>Tente novamente mais tarde ou ajuste seus filtros.</span>
                                    </>
                                )}
                            </div>
                        )
                    }
                    <Pagination
                        currentPage={this.state.currentPage}
                        totalPages={this.state.totalPages}
                        onPageChange={this.handlePageChange}
                    />
                </div>
                {false && (
                    <NewsletterSignup
                        name={name}
                        email={email}
                        onChange={this.handleChange}
                        onSubmit={() => console.log('Cadastrar newsletter')}
                    />
                )}
                <Footer />
            </div>
        );
    }
}

export default Articles;
